import React from "react";

/**
 * World Visionary Times — plain premium wordmark.
 * All caps, generously letter-spaced Fraunces serif, italic middle word.
 * No decorative rules, no tagline. Pure editorial mark on transparent bg.
 */
const Logo = ({ className = "", size = "md", "data-testid": testId = "site-logo" }) => {
  const heights = { xs: 16, sm: 20, md: 26, lg: 34 };
  const h = heights[size] || heights.md;

  return (
    <svg
      data-testid={testId}
      className={className}
      viewBox="0 0 460 40"
      height={h}
      xmlns="http://www.w3.org/2000/svg"
      aria-label="World Visionary Times"
      role="img"
      style={{ display: "block" }}
    >
      <text
        x="230"
        y="29"
        textAnchor="middle"
        fontFamily="'Fraunces', 'Playfair Display', Georgia, serif"
        fontWeight="500"
        fontSize="28"
        letterSpacing="1.6"
        fill="#0F0F10"
      >
        WORLD <tspan fontStyle="italic" fontWeight="400">Visionary</tspan> TIMES
      </text>
    </svg>
  );
};

export default Logo;
